export const DASHBOARD_ROUTE = {
    MAIN: '/dashboard',
    HOME: '/'
} as const;

export const INVITE_ROUTE = {
    JOIN: '/join/:inviteId',
} as const;

export const LANDING_ROUTE = {
    WAITLIST: '/waitlist',
    SPLASH: '/'
} as const;

export const REWARD_ROUTE = {
    MAIN: '/rewards'
} as const;

export const SURVEY_ROUTE = {
    MAIN: '/surveys'
} as const;

export const SUPPORT_ROUTE = {
    MAIN: '/support'
}